const templateParamsActions = {
  TEMPLATE_PARAMS_INIT: 'TEMPLATE_PARAMS_INIT',
  TEMPLATE_PARAMS_SET: 'TEMPLATE_PARAMS_SET',
  TEMPLATE_PARAMS_TEXT_TAG_UPDATE: 'TEMPLATE_PARAMS_TEXT_TAG_UPDATE'
};
export default templateParamsActions;
